<template>
    <div class="select-material-modal">
        <h5 class="mb10 pl10">该广告下有多个素材，请选择其中一个素材添加</h5>
        <div class="list">
            <div class="item" v-for="(item, index) in materialList" :key="index">
                <div class="img-box">
                    <preview :info="item?.material_info">
                        <template v-slot:checkBox>
                            <!-- <el-radio v-model="radio" :label="index" @change="selectMaterial"></el-radio> -->
                            <div style="cursor: pointer;" @click="selectMaterial(index)">
                                <i class="el-icon-circle-check" v-if="index === actived"></i>
                                <i class="el-ran" v-else></i>
                            </div>
                        </template>
                    </preview>
                </div>
                <div class="info_item_con">
                    <div class="label">素材名称：</div>
                    <div class="value">{{ item?.material_info?.material_name }}</div>
                </div>
                <div class="info_item_con">
                    <div class="label">MD5：</div>
                    <div class="value">{{ item?.material_info?.material_md5 }}</div>
                </div>
            </div>
        </div>
        <div class="mt20" style="text-align: center;">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSure">确定</el-button>
        </div>
    </div>
</template>
<script>
import preview from '../components/preview.vue';
export default {
    name: 'selectMaterialModal',
    props: {
        cbs:{
            type:Object,
        },
        materialList: {
            type: Array,
            default: () => [
                {   
                    "material_info": {
                        "cid": "1826862",
                        "material_name": "狂野风暴-缓存图.png",
                        "material_md5": "f538a5118997141f9d85c64a9fcf3e5b",
                        "material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                        "img_material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                        "height": "2400",
                        "width": "1080",
                        "material_size": "762.76",
                        "material_size_unit": "KB",
                        "material_duration": "-",
                        "material_format": "png",
                        "material_type": "1"
                    },
                    "project_info": {
                        "plat_id": "1",
                        "plat_name": "OPPO",
                        "account_id": "24",
                        "ad_id": "1",
                        "create_time": "151",
                        "yy_user": "负责人"
                    }
                },
                {
                    "material_info": {
                        "cid": "1826862",
                        "material_name": "狂野风暴-缓存图.png",
                        "material_md5": "f538a5118997141f9d85c64a9fcf3e5b",
                        "material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                        "img_material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                        "height": "2400",
                        "width": "1080",
                        "material_size": "762.76",
                        "material_size_unit": "KB",
                        "material_duration": "-",
                        "material_format": "png",
                        "material_type": "1"
                    },
                    "project_info": {
                        "plat_id": "1",
                        "plat_name": "OPPO",
                        "account_id": "24",
                        "ad_id": "1",
                        "create_time": "151",
                        "yy_user": "负责人"
                    }
                }
            ]
        }
    },
    components: {
        preview
    },
    data() {
        return {
            actived: ''
        }
    },
    computed: {

    },
    methods: {
        selectMaterial(index) {
            console.log('selectMaterial',index);
            this.actived = index
        },
        handleCancel() {
            this.$emit('close');
        },
        handleSure() {
            if (!this.materialList[this.actived]) {
                this.$message.error('请选择要插入比对的素材')
                return;
            }
            this.cbs.onSubmit(this.materialList[this.actived])
        }
    }
};
</script>
<style lang="scss" scoped>
.select-material-modal {
    width: 100%;

    .list {
        display: flex;
        justify-content: space-between;
        position: relative;
        max-height: 60vh;
        overflow-y: auto;
        .item {
            width: 50%;
            padding: 0 10px;
        }
    }

    .info_item_con {
        display: flex;
        align-items: flex-start;
        width: 100%;
        font-size: 12px;
        padding-bottom: 2px;
        line-height: 22px;
        margin-bottom: 6px;

        .label {
            min-width: 64px;
            display: block;

        }

        .value {
            /*flex: 1;*/
            overflow-x: hidden;
            word-wrap: break-word;
            display: block;
            color: #333;
        }

        .overflowCon {
            overflow-x: auto;

            .overflowCon_a {
                //min-width: 250px;
                display: flex;
                flex-direction: column;

                a {
                    white-space: nowrap;
                }
            }
        }
    }
    .el-ran{
        width: 30px;
        height: 30px;
        border: 2px solid #606266;
        border-radius: 100%;
        display: block;
    }
    .el-icon-circle-check{
        font-size: 32px;
        color: #409EFF;
    }
}
</style>